<template>
  <b-alert
    :show="dismissCountDown"
    dismissible
    :variant="$props.variant"
    @dismissed="dismissCountDown = 0"
    @dismiss-count-down="countDownChanged"
  >
    {{ $props.message }}
  </b-alert>
</template>

<script>
export default {
  name: "HAlert",
  props: {
    message: String,
    variant: String,
    dismissSecs: Number,
  },
  data() {
    return {
      dismissCountDown: this.$props.dismissSecs,
    };
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
  },
};
</script>

<style scoped></style>
